import { supabase } from '../supabase/client';

/**
 * Converts a storage UUID to a public URL
 * 
 * Phase 1: Public URLs (current implementation)
 * - Fast performance (1-5ms overhead)
 * - Security through obscurity (UUIDs are unguessable)
 * 
 * Phase 2: Signed URLs (future migration)
 * - Uncomment the signed URL implementation below
 * - Requires edge function setup
 * - 150-250ms per image
 * 
 * Phase 3: Authenticated Download (alternative migration)
 * - Uncomment the download implementation below
 * - 300-500ms per image
 * - No edge function needed
 * 
 * @param {string} uuid - The UUID of the image in storage
 * @param {string} bucket - The storage bucket name (default: 'chat-images')
 * @returns {string} The public URL for the image
 */
export function getImageUrl(uuid, bucket = 'chat-images') {
  if (!uuid) return null;
  
  // Phase 1: Public URL (current)
  const { data } = supabase.storage.from(bucket).getPublicUrl(uuid);
  return data.publicUrl;

  // Phase 2: Signed URL (future migration)
  // const { data } = await supabase.functions.invoke('get-signed-url', { uuid, bucket });
  // return data.signedUrl;

  // Phase 3: Authenticated Download (alternative migration)
  // const { data } = await supabase.storage.from(bucket).download(uuid);
  // return URL.createObjectURL(data);
}

/**
 * Generates a UUID for a new image file
 * @returns {string} A new UUID
 */
export function generateImageUuid() {
  return `img-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
